//vendor
import React, { Fragment, useState } from 'react'
import {TextField, Grid, MenuItem} from '@material-ui/core'
import {useHistory} from 'react-router-dom'
//controller
import {RegisterController} from '../../../Controller'



import{CheckEmail} from '../../../Config/Validation'
//css
import '../../../Css/RegisterTemplate.scss'
import { Alert } from '@material-ui/lab'


function RegisterForm(props){
    const history = useHistory()
    
    const [state, setstate] = useState({
        email:'',
        password:'',
        name:'',
        birthDate:'1945-08-17',
        gender:'Male',
    })

    const [validationState, setvalidationState] = useState({
        email:{
            statusError:false,
            message:""
        },
        password:{
            statusError:false,
            message:""
        },
        name:{
            statusError:false,
            message:""
        },
       
       
    })

    const onSubmit = async (event) => {
        
        if (HandleValidation()){
            props.Loading(true)
            await RegisterController(state).then(res=>{ 
               alert("Registration Success")
               alert("Silahkan Login Kembali")
               props.Loading(false)
            })
        }
       
    }

    const onInputHandle = (event) => {
        const {name, value} = event.target
        setstate(prev=>({
            ...prev,
            [name]:value
        }))
        
        
    }

    
    
    const HandleValidation = () => {
        let status = false
        if(state.name.length==0){
            setvalidationState(prev=>({
                ...prev,
                name:{
                    statusError:true,
                    message:"FIll the name"
                }
            }))
        }
        else if(!CheckEmail(state.email)){
            setvalidationState(prev=>({
                ...prev,
                email:{
                    statusError:true,
                    message:"Email Wrong Format"
                }
            }))
        }
        else if(state.password.length < 11){
            setvalidationState(prev=>({
                ...prev,
                password:{
                    statusError:true,
                    message:"Password Min 11 Char"
                }
            }))
        }
        else{
            status=true
        }

        return status
    }
    

    return(
        <Fragment>
           
        <div className="regisParent">
            
            <div className="descWrapperTitle_Register">
                    <h3>Create Your Own</h3>    
            </div>
            <form action="" noValidate autoComplete="off" method="POST">
            <div className="regisWrapper">
                
                <div className="InputWrapper">
                    <Grid container spacing={1} alignItems="flex-end">
                     
                        <Grid item>
                            <TextField  
                                name="name" 
                                label="Nama" 
                                value={state.name} 
                                onInput={event => onInputHandle(event)}
                                error={validationState.name.statusError}
                                helperText={validationState.name.message}
                               
                            />
                        </Grid>
                    </Grid>
                </div>
                <div className="InputWrapper">
                    <Grid container spacing={1} alignItems="flex-end">
                     
                        <Grid item>
                            <TextField 
                                name="email" 
                                label="Email" 
                                value={state.email} 
                                onInput={event => onInputHandle(event)}
                                error={validationState.email.statusError}
                                helperText={validationState.email.message}     
                            />
                        </Grid>
                    </Grid>
                </div>
                <div className="InputWrapper">
                    <Grid container spacing={1} alignItems="flex-end">
                    
                       <Grid item> 
                            <TextField  
                                name="password" 
                                label="Password" 
                                type="password" 
                                value={state.password} 
                                onInput={event=>onInputHandle(event)}
                                error={validationState.password.statusError}
                                helperText = {validationState.password.message}
                            />
                                
                       </Grid>
                   </Grid>
                </div>
                <div className="InputWrapper">
                    <Grid container spacing={1} alignItems="flex-end">
                    
                       <Grid item> 
                        <TextField
                            name="birthDate"
                            label="Birth Day"
                            type="date"
                            defaultValue={state.BirthDate}
                            value={state.BirthDate}
                            onInput={event=> onInputHandle(event)}
                            InputLabelProps={{
                            shrink: true,
                            }}
                        />
                       </Grid>
                   </Grid>
                </div>
                <div className="InputWrapper">
                    <Grid container spacing={1} alignItems="flex-end">
                       
                        <Grid item>
                        <TextField
                            name="gender"
                            select
                            label="Gender"
                            onChange={event=>onInputHandle(event)}
                            value = {state.gender}
                            
                           
                        >
                            {Gender.map((option) => (
                                <MenuItem key={option.value} value={option.string}>
                                {option.string}
                                </MenuItem>
                            ))}                            
                        </TextField>
                        </Grid>
                    </Grid>
                </div>
               
                
            </div>
            <div className="buttonWrapper">
                    <div className="buttonRegister">
                        <button type="button" onClick={onSubmit}>Register</button>
                    </div>
                    <div className="buttonBack">
                        <button type="button" onClick={props.setTriggeregister}>Back</button>
                    </div>
                </div>
            </form>
            
            
        </div>
        
    </Fragment>
    )
}

const Gender = [
    {
      string: 'Male', 
    },
    {
      string: 'Female',  
    },

  ];

  


  
export default RegisterForm